module.exports = __webpack_public_path__ + "b495432f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/ClinicaMedica/24580.jpg
// module id = 1317
// module chunks = 0 1